export default "__VITE_ASSET__ccc46cbf__"